var map = {
	"./burgures/5882486ce81acb96424ffaae.png": "a29b",
	"./burgures/Big Burger .png": "e344",
	"./burgures/Burger Fries.png": "59f8",
	"./burgures/Chicken Burger.png": "9efe",
	"./burgures/Fish Burger.png": "88f3",
	"./burgures/KFC Double .png": "e0d8",
	"./chickens/Kfc Chicken Nuggets.png": "b098",
	"./chickens/Kfc Signature Box.png": "1568",
	"./chickens/Kfc Twister Box.png": "a1c2",
	"./chickens/alyssa-li-n2z5UL4E4Og-unsplash.jpg": "bd87",
	"./chickens/plate-of-rice-and-cooked-meat-1624487.jpg": "1100",
	"./chickens/tsering-pemba-_ccJa73HR2I-unsplash.jpg": "3868",
	"./desserts/Ice Cream Berries.png": "0577",
	"./desserts/Strawberry Horn Ice Cream.png": "68ed",
	"./desserts/Strawberry Parfait Ice Cream.png": "9418",
	"./drinks/Can Pepsi .png": "acdc",
	"./drinks/Coca Cola Papercup.png": "6e5b",
	"./drinks/Coke Light Bottle Coca Cola.png": "d6a2",
	"./drinks/Fanta Orange Bottle .png": "6502",
	"./drinks/Fanta Orange Can.png": "c54e",
	"./drinks/Glass Bottle Pepsi .png": "e81c",
	"./drinks/Plastic Bottle Pepsi .png": "40d7",
	"./drinks/Regular Coke Can Coca Cola.png": "a964",
	"./pizza/close-up-photo-of-pizza-2619970.jpg": "7773",
	"./pizza/jonas-kakaroto-BHdZZQWrcwM-unsplash.jpg": "70c3",
	"./pizza/muhammad-umair-TxQSdnp6D_k-unsplash.jpg": "5f06",
	"./pizza/pizza.png": "8117",
	"./pizza/pizza_one.png": "6374",
	"./pizza/pizza_three.png": "da4d",
	"./pizza/thomas-tucker-MNtag_eXMKw-unsplash.jpg": "f33d",
	"./salad/Fattoush Salad with Cashew Nuts.png": "5d15",
	"./salad/Fattoush Salad with Cucumber and Tomato.png": "f43b",
	"./salad/Fattoush Salad.png": "8028",
	"./salad/Lamb Kebab With Salad.png": "5739",
	"./sauces/Yoghurt Cucumber Sauce.png": "5abb"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5a18";